<template lang="html">
  <div class="characteristics">
    <ul class="characteristics__list">
      <li
        v-for="(_, index) in $t(characteristicKeys)"
        :key="index"
        class="characteristics__list-element"
      >
        <Characteristic
          :icon-name="icons[index]"
          :title="$t(`${characteristicKeys}[${index}].title`)"
        >
          <i18n
            :path="`${characteristicKeys}[${index}].description`"
          >
            <template #link>
              <Link :href="urls[index]">
                <span>{{ $t(`${characteristicKeys}[${index}].link`) }}</span>
              </Link>
            </template>
          </i18n>
        </Characteristic>
      </li>
    </ul>
  </div>
</template>

<script>
import Characteristic from '@/components/pages/features/common/characteristics/Characteristic'
import Link from '@/components/common/Link/Link'

export default {
  components: {
    Characteristic,
    Link
  },

  props: {
    characteristicKeys: {
      type: String,
      required: true
    },
    icons: {
      type: Array,
      default: () => []
    },
    urls: {
      type: Array,
      default: () => []
    }
  }

}
</script>

<style lang="scss" scoped>
.characteristics {
  background-color: #25163a;
  width: 100%;
  padding: $gap * 5 $gap;

  &__list {
    max-width: 1120px;
    margin: 0 auto;
    display: flex;
    gap: $gap * 1.5;
    flex-direction: row;
    justify-content: center;
    list-style-type: none;

    @include display-less(desktop) {
      width: fit-content;
      flex-direction: column;
    }

    &-element {
      flex: 1;
    }
  }
}
</style>
